import { alpha } from '@mui/material/styles'

import { constants } from '../config'

const { catNames } = constants

export const linearProgressTintedSx = (theme, barColor) => ({
  flex: 1,
  height: 6,
  borderRadius: 1,
  backgroundColor: alpha(theme.palette.common.white, 0.12),
  '& .MuiLinearProgress-bar': {
    backgroundColor: barColor
  }
})

export const emptyGraphData = {
  [catNames.BILLING]: { datasets: [], labels: [] },
  [catNames.TRACKING]: { datasets: [], labels: [] },
  [catNames.SP_MONTHLY]: { datasets: [], labels: [] },
  [catNames.AI_BILLING]: { datasets: [], labels: [] },
  [catNames.AI_SP_MONTHLY]: { datasets: [], labels: [] },
  [catNames.AI_TRACKING]: { datasets: [], labels: [] },
  [catNames.AI_TICKET_SP]: { datasets: [], labels: [] },
  [catNames.TICKETS_MONTHLY]: { datasets: [], labels: [] }
}

export const buildEmptyTabStats = () => ({
  Dollars: { sum: 0, avg: 0 },
  SP: { sum: 0, avg: 0 },
  Units: { sum: 0, avg: 0 },
  TicketCount: { sum: 0, avg: 0 },
  DollarsPerSP: { sum: 0, avg: 0 },
  DollarsPerUnit: { sum: 0, avg: 0 },
  UnitsPerItem: { sum: 0, avg: 0 },
  Items: { sum: 0, avg: 0 },
  Deficit: { sum: 0, avg: 0 },
  DataPoints: { sum: 0 }
})
